import type { TouristSpot } from "@/services/touristSpotService";

interface SpotMapProps {
  spot: TouristSpot;
}

/**
 * Sidebar map card — sits at the very top of the spot detail sidebar, with the
 * full address and an "Get directions" action, mirroring the business profile.
 */
export default function SpotMap({ spot }: SpotMapProps) {
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(spot.address)}&z=12&output=embed`;
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    spot.address,
  )}`;

  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="border-b border-background-200 p-5 pb-4">
        <h3 className="flex items-center gap-2 font-heading text-sm font-bold uppercase tracking-wider text-foreground-900">
          <span className="flex h-4 w-4 items-center justify-center text-primary-600">
            <i className="ri-map-2-line text-base" />
          </span>
          Location
        </h3>
        <p className="mt-2 text-sm text-foreground-600">{spot.address}</p>
      </div>

      <iframe
        title={`Map of ${spot.name}`}
        src={mapSrc}
        className="h-56 w-full border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />

      <div className="p-4">
        <a
          href={directionsUrl}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-primary-600"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-navigation-line text-base" />
          </span>
          Get directions
        </a>
      </div>
    </div>
  );
}